// extracted by mini-css-extract-plugin
export var labelBox = "nested-nav-module--label-box--55ce5";